import { Directive, ElementRef, Input, OnInit } from '@angular/core';

const loadImage = (element, url) => {
  let image = document.createElement('img');

  image.addEventListener('load', () => {
    if (element.tagName == 'IMG') {
      element.src = url;
    } else {
      element.style['backgroundImage'] = `url('${url}')`;
    }
  });
  image.addEventListener('error', () => {
  });

  image.src = url;
};

@Directive({
  selector: '[draImage]'
})
export class DraImageDirective implements OnInit{
  @Input('draImage') imageUrl: string;

  constructor(private element: ElementRef) {
  }
  ngOnInit() {
    loadImage(this.element.nativeElement, this.imageUrl);
  }
}



// WEBPACK FOOTER //
// ./src/directives/dra-image.directive.ts